<template>
    <div class="ended">
        <div class="ended__content">
            <div class="ended__score" v-if="user">
                <div class="ended__score__number">+ {{completedWorkoutData.score}}</div>
                <div class="ended__score__label" v-translate>trac_score</div>
            </div>
            <div class="ended__section">
                <div class="ended__title h2">{{workout.title}}</div>
                <div class="ended__subtitle subtitle">{{workout.subtitle}}</div>
            </div>
            <div class="ended__section ended__section--center">
                <div class="ended__duration">
                    <div class="duration">{{formatDuration(workout.duration)}}</div>
                    <div class="text" v-translate>min_abbr</div>
                </div>
                <div class="ended__info" v-if="user">{{completedWorkoutData.calories}} <translate>calories_burned</translate></div>
            </div>
            <div class="ended__section">
                <div class="ended__rating-title h5" v-if="user" v-translate>rate_this_workout</div>
                <div class="ended__rating" v-if="user">
                    <StarRating @ratingUpdate="updateRating"></StarRating>
                </div>
                <puma-button :type="'light'" :link="'/'" class="ended__button"><translate>done</translate></puma-button>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '../api';
import StarRating from '@/components/StarRating'
import { mapGetters } from "vuex"

export default {
    components: {
        StarRating
    },
    props: {
        workout: {
            type: Object
        },
        completedWorkout: {
            type: Object
        }
    },
    data() {
        return {
            rating: 0,
            completedWorkoutData: this.completedWorkout,
            completeResponse: false,
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    mounted() {
        this.calculateScoreAndDurations()

        setTimeout(() => {
            this.sendCompleteWorkout()
        }, 300);
    },
    beforeDestroy() {
        if(this.rating > 0) {
            this.rateWorkout()
        }
    },
    methods: {
        formatDuration(time) {
            return Math.round(time / 60);
        },
        updateRating(e) {
            this.rating = e
        },
        calculateScoreAndDurations() {
            let exercisedurationSum = 0
            this.$set(this.completedWorkoutData, 'duration', 0)
            this.$set(this.completedWorkoutData, 'score', 0)
            this.$set(this.completedWorkoutData, 'calories', 0)
            this.completedWorkout.completedExercises.forEach(exercise => {
                exercisedurationSum += exercise.duration
                this.completedWorkoutData.score += Math.round(exercise.score)
                this.completedWorkoutData.calories += Math.round(exercise.calories)
            })

            const estimatedDurationRounded = Math.ceil(this.workout.duration / 60.0) * 60
            this.completedWorkoutData.duration = exercisedurationSum > estimatedDurationRounded ? exercisedurationSum : estimatedDurationRounded 
        },
        async sendCompleteWorkout() {
            try {
                const response = await api.users.completeWorkout({completedWorkout: this.completedWorkout})
                this.completeResponse = response.data.data
            } catch (error) {
                console.error(error);
            }
        },
        async rateWorkout() {
            try {
                const ratingData = {
                    rating: this.rating,
                    completedWorkoutId: this.completeResponse.id,
                    timestamp: new Date().toISOString()
                }
                await api.workout.rate({id: this.workout.id, ratingData: ratingData})
            } catch (error) {
                console.error(error);
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "~sass-mq";

.ended {
    background: rgba($puma-color-neutral-20, 0.2);
    text-align: center;
    width: (4 * 100% / 12);
    min-width: 410px;

    @include mq($until: tablet) {
        width: 100%;
        min-width: 0;
    }

    @include mq($until: mobile-landscape) {
         width: calc(100% - #{$page-padding-small});
    }

    &__content {
        position: relative;

        @include mq($until: tablet) {
            padding-top: 30px;
        }
    }

    &__score {
        position: absolute;
        top: -30px;
        right: -30px;
        width: 100px;
        height: 100px;
        background-color: white;
        color: black;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: bold;

        @include mq($until: tablet) {
            width: 75px;
            height: 75px;
            top: -30px;
            right: -10px;
        }

        &__number {
            font-size: $puma-size-font-3xl;
            line-height: 1.1;

            @include mq($until: tablet) {
                font-size: $puma-size-font-xl;
            }
        }

        &__label {
            font-size: $puma-size-font-xs;
            text-transform: uppercase;

            @include mq($until: tablet) {
                font-size: $puma-size-font-xxs;
            }
        }
    }

    &__section {
        padding: 40px;
        border-bottom: 1px solid rgba(white, 0.3);

        @include mq($until: tablet) {
            padding: $page-padding-small;
        }

        &:last-child {
            border-bottom: none;
        }

        &--center {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__duration {
        padding-right: 20px;
        margin-right: 20px;
        border-right: 1px solid rgba(white, 0.3);

        &:only-child {
            border: none;
            padding: 0;
            margin: 0;
        }

        .duration {
            font-size: $puma-size-font-2xl;
            font-weight: $font-weight-bold;
            margin-bottom: -8px;
        }
    }

    &__rating {
        margin-top: 26px;
    }

    &__button {
        margin-top: 32px;
        width: 100%;

        &:only-child {
            margin: 0;
        }
    }
}
</style>